<template>
	<AppLayout :title="trans('menu.association.representatives.rotations')">
		<Empty v-if="rotations.data.length === 0"/>
		<template v-else>
			<Pagination :resource="rotations"/>
			<CardGrid>
				<RotationComponent v-for="rotation in rotations.data" :key="`rotation-${rotation.id}`" :rotation="rotation"/>
			</CardGrid>
			<Pagination :resource="rotations"/>
		</template>
	</AppLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import Empty from '@/Components/UI/Empty.vue'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import Pagination from '@/Components/UI/Pagination.vue'
import CardGrid from '@/Components/UI/Cards/CardGrid.vue'
import {type Rotation} from '@/Types/Periods/Rotations/Rotation'
import {type PaginatedModel} from '@/Types/Pagination/PaginatedModel'
import RotationComponent from '@/Components/Association/Representatives/Rotation.vue'

const props = defineProps<{
	rotations:PaginatedModel<Rotation>,
}>()

const rotations:Ref<PaginatedModel<Rotation>> = ref(props.rotations)
</script>